const ValidBackgroundColorNames = [
  'none',
  'green',
  'violet',
  'pink',
  'lightGreen',
  'lightViolet',
  'lightPink',
  `darkViolet`,
] as const;

export type BackgroundColorName = (typeof ValidBackgroundColorNames)[number];

const ColorsConfig = {
  none: '',
  green: 'bg-green-800',
  violet: 'bg-violet-800',
  pink: 'bg-pink-800',
  lightGreen: 'bg-green-100',
  lightViolet: 'bg-violet-100',
  lightPink: 'bg-pink-100',
  darkViolet: 'bg-violet-900',
} as const satisfies Record<BackgroundColorName, string>;

const DefaultBackgroundColor: BackgroundColorName = 'green';

const isValidBackgroundColorName = (colorName: string): colorName is BackgroundColorName =>
  ValidBackgroundColorNames.includes(colorName as BackgroundColorName);

export const mapBackgroundColor = (colorName: string): string => {
  if (!isValidBackgroundColorName(colorName)) return ColorsConfig[DefaultBackgroundColor];

  return ColorsConfig[colorName];
};
